const Code = () => (
  <div id="Code">
		<h2>Code</h2>
    -Also put code projects and links to their githubs and why I like them or am proud of them.-
    <a className="App-link" href="https://github.com/funkjunky">Github</a>
  </div>
);

export default Code;
